import MultiEditCheckComfirm from './MultiEditCheckComfirm';

export default MultiEditCheckComfirm;
